import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import { Card } from 'reactstrap';
import Spinner from '~/components/spinner/spinner';
import FilterInput from '~/components/filterInput/filterInput';
import URLParamBanner from '~/components/urlParamBanner/urlParamBanner';
import ErrorBoundaryContent from '~/components/errorBoundary/content';

export const getCustomersQuery = gql`
  query customers($breweryId: Int!) {
    customers(breweryId: $breweryId) {
      id
      name
      contactName
    }
  }
`;

export class CustomerList extends Component {
  state = {
    filteredCustomers: [],
    filterText: ''
  };

  onFilterChange = (event, customers) => {
    const { value } = event.target;
    if (!value.length) {
      return this.setState({
        filteredCustomers: [],
        filterText: ''
      });
    }
    const filterValue = value.toLowerCase();

    const filteredCustomers = customers.filter(customer => {
      return (
        customer.name.toLowerCase().indexOf(filterValue) !== -1 ||
        customer.contactName.toLowerCase().indexOf(filterValue) !== -1 ||
        customer.phone.toLowerCase().indexOf(filterValue) !== -1 ||
        customer.email.toLowerCase().indexOf(filterValue) !== -1
      );
    });

    return this.setState({
      filterText: value,
      filteredCustomers
    });
  };

  render() {
    const { brewery, history } = this.props;
    return (
      <Query query={getCustomersQuery} variables={{ breweryId: brewery.id }} fetchPolicy={'cache-and-network'}>
        {props => {
          const { loading, error, data } = props;
          if (loading) {
            return <Spinner className="absolute absolute-center stroke-brand-red" />;
          }

          if (error) {
            return <ErrorBoundaryContent error={error} />;
          }

          return (
            <Fragment>
              <URLParamBanner name="customer" />
              <Card className="content">
                <div className="flex pa3 w-100">
                  <FilterInput onChange={e => this.onFilterChange(e, data.lots)} className="flex-grow-1" />
                </div>
                <div>
                  <header className="flex ttu table-header pv2">
                    <div className="w-60 pl3">Name</div>
                    <div className="w-40">Contact person</div>
                  </header>

                  <div>
                    {data.customers.map(customer => (
                      <div
                        className="flex pointer pv3 bt-divider row-hover items-center"
                        key={customer.id}
                        onClick={() => {
                          history.push(`/customers/${customer.id}`);
                        }}
                      >
                        <div className="w-60 pl3">{customer.name}</div>
                        <div className="w-40">{customer.contactName}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </Card>
            </Fragment>
          );
        }}
      </Query>
    );
  }
}

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(withRouter(CustomerList));



// WEBPACK FOOTER //
// ./src/containers/customerList/customerList.jsx